/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown>, temporaryPassword: NonNullable<unknown>, appUrl: NonNullable<unknown> }} Cognito_Invitation_Plain_MessageInputs */

const en_cognito_invitation_plain_message = /** @type {(inputs: Cognito_Invitation_Plain_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your username is ${i?.username} and your temporary password is ${i?.temporaryPassword}. Access ${i?.appUrl}. For security reasons, you must set a new password on your first sign-in.`)
};

const pt_br2_cognito_invitation_plain_message = /** @type {(inputs: Cognito_Invitation_Plain_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu usuário é ${i?.username} e sua senha temporária é ${i?.temporaryPassword}. Acesse ${i?.appUrl}. Por motivos de segurança, você precisará definir uma nova senha no primeiro acesso.`)
};

/**
* | output |
* | --- |
* | "Your username is {username} and your temporary password is {temporaryPassword}. Access {appUrl}. For security reasons, you must set a new password on your fi..." |
*
* @param {Cognito_Invitation_Plain_MessageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_plain_message = /** @type {((inputs: Cognito_Invitation_Plain_MessageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_Plain_MessageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_plain_message(inputs)
	return pt_br2_cognito_invitation_plain_message(inputs)
});